export const square = {
	name: 'Untitled Square Template',
	variant: 'design',
	json: {
		width: 1080,
		height: 1080,
		fonts: [],
		pages: [
			{
				id: 'page_1',
				children: [],
				width: 'auto',
				height: 'auto',
				background: 'white',
				bleed: 0,
			},
		],
		unit: 'px',
		dpi: 96,
	},
	status: 'draft',
	history: [],
	tags$Category: [],
	tags$General: [
		'0:Medium:Digital',
		'0:Distribution:Social',
		'0:Format:Post',
		'0:Format:Ad',
		'0:Layout:Square',
		'0:Dimensions:1080x1080',
		'0:Network:Facebook',
		'0:Network:LinkedIn',
		'0:Network:X',
	],
	etc: {
		directives: {},
		cfg: {
			global: {
				minPages: 1,
				maxPages: 50,
			},
			customer: {
				minPages: 1,
				maxPages: 50,
			},
			order: {
				countries: null,
				itemId: 'square',
			},
			canBeResized: true,
		},
	},
};

export default square;
